import ethereum from '../ethereum.js';
import {web3} from '../web3.js';
import myIpfs from '../Ipfs.js';
var Web3 = require('web3');
var ipfsAPI = require('ipfs-api');

const bs58 = require('bs58')

const ipfs = ipfsAPI('localhost', '5001', {protocol: 'http'});

const BLOCK_CHUNK_SIZE = 70000;

Date.prototype.formatMMDDYYYY = function(){
    return (this.getMonth() + 1) + 
        "/" +  this.getDate() +
        "/" +  this.getFullYear();
}

class Pinner {
    constructor(contract, topics, ipfsIndex, provide=false, byChunks=false) {
        this.contract = new web3.eth.Contract(contract.abi, contract.contractAddress);
        this.topics = topics;
        this.ipfsIndex = ipfsIndex;
        this.pinningSounds = new Set();
        this.pinnedSounds = new Set();
        this.failedSounds = new Set();
        this.queuedSounds = new Set();
        this.providedSounds = 0;
        this.provide = provide;
        this.byChunks = byChunks;
        this.badBlockRanges = [];
        this.localRefs = new Set();
        this.currentBlockDate = new Date();

        this.yo();
    }

    getStats() {
        return {
            date: this.currentBlockDate,
            pinned: this.pinnedSounds,
            pinning: this.pinningSounds,
            local: this.localRefs,
            queued: this.queuedSounds,
            failed: this.failedSounds,
        };
    }

    async yo() {
        console.log('getting ipfs refs');
        ipfs.refs.local((err, hashes) => {
            if (err) {
                return;
            }
            console.log(err);
            console.log('ipfs local returned');
            console.log(hashes);
            this.localRefs = new Set(hashes.map(
                h => h.Ref));
        });
    }

    watchAndPin() {
        web3.eth.subscribe(
            'logs',
            {
                address: this.contract.options.address,
                topics: this.topics,
                fromBlock: '0x1'
            },
            (err, result) => {
                if (err) {
                    console.log(err);
                    return;
                }
                if (result === undefined || result == null) {
                    console.log('there was nothing...');
                    return;
                }
                console.log('got a log to pin!');
                this.robustPin(bytes32ToIPFSHash(result.topics[this.ipfsIndex]));
            });
    }

    async pinAll() {
        let blockNumber = await web3.eth.getBlockNumber();
        console.log('BLOCK NUMBER RETURNED =' + blockNumber);

        this.pinAllHelper(3000000, blockNumber, BLOCK_CHUNK_SIZE)
    }

    async pinAllHelper(fromBlock, toBlock, blockChunkSize, redoFailures=true) {
        let badBlockRanges = [];
        console.log('pin all called');
        if (!this.byChunks) {
            this.pinFromBlockToBlock(1, undefined);
        } else {
            let blockNumber = toBlock;
            console.log('block number = ' + blockNumber);
            while (blockNumber >= fromBlock) {
               try {
                    await this.pinFromBlockToBlock(blockNumber - blockChunkSize, blockNumber);
                    await this.sleep(550);
                } catch (err) {
                    console.log('encountered error while pinning blockNumber = ' + blockNumber);
                    console.log(err);
                    badBlockRanges.push(blockNumber);
                    console.log('bad block ranges = ');
                    console.log(badBlockRanges);
                }
                blockNumber -= blockChunkSize;
            }

            console.log('completed');
            for (let i in badBlockRanges) {
                let fromBlock = badBlockRanges[i] - blockChunkSize;
                let toBlock = badBlockRanges[i];
                await this.pinAllHelper(fromBlock, toBlock, Math.ceil(blockChunkSize / 2), false);
            }
        }
    }


    async pinFromBlockToBlock(fromBlock, toBlock) {
        this.currentBlockDate = new Date((await web3.eth.getBlock(fromBlock)).timestamp*1000);
        return new Promise((resolve, reject) => {
            try {
                web3.eth.getPastLogs({
                    address: this.contract.options.address,
                    topics: this.topics,
                    toBlock: web3.utils.toHex(toBlock),
                    fromBlock: web3.utils.toHex(fromBlock),
                }, async (err, results) => {
                    if (err) {
                        console.log("GOT ERROR WHILE GETTING PAST LOGS!");
                        reject();
                        return;
                    }
                    
                    results.reverse();
                    
                    if (results.length > 0) {
                        console.log('got ' + results.length + ' many files to pin in this range');
                    }
                    await this.pinHashes(
                        results
                            .map(result => result.topics[this.ipfsIndex])
                            .map(result => bytes32ToIPFSHash(result)));
                    
                    resolve();
                });
            } catch (err) {
                console.log(err);
                reject(err);
            }
        });
    }

    sleep(ms) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve()
            }, ms);
        });
    }

    async pinHashes(sounds) {
        if (this.localRefs.has !== undefined) {
            sounds = sounds.filter(
                s =>
                    !this.localRefs.has(s));
        } else {
            console.log('didnt have local ref');
        }

        sounds = Array.from(new Set(sounds));
        sounds.forEach(s => this.queuedSounds.add(s));
        
        let failed = [];
        let batchSize = 8;
        for (let i=0; i < sounds.length; i += batchSize) {
            let trying = [];
            try {
                let promises = [];
                for (let j=i; j < i + batchSize && j < sounds.length; j++) {
                    trying.push(sounds[j]);
                    promises.push(this.pin(sounds[j]));
                }
                await Promise.all(promises);
		let y = await this.sleep(100);
            } catch (err) {
                console.log('IMPORTANT ERROR had err = ' + err);

                failed = failed.concat(trying);
                for (let i in failed) {
                    this.failedSounds.add(failed[i]);
                    if (this.pinningSounds.has(failed[i])) {
                        this.pinningSounds.delete(failed[i]);
                    }
                }
            }
        }
    }

    async robustPin(hash, retries=0) {
        try {
            console.log('pinning ' + hash);
            let x = await this.pin(hash);
        } catch (e) {
            console.log('had error pinning = ');
            console.log(e);
        }
    }

    pin(hash) {
        return new Promise(async (resolve, reject) => {
            let title = '';
            this.pinningSounds.add(hash);
            this.queuedSounds.delete(hash);
            if (this.pinningSounds.size % 20 === 0) {
                title = await ethereum.getTitleForSound(hash);
            }

	
            let success = false;
            setTimeout(() => {
                if (!success) {
                    reject('timed out so failing');
                } else {
                    resolve();
                }
            }, 60000);
            if (title !== '') {
	        console.log('pinning i = ' + this.pinningSounds.size + ' ' + title);
            }

            try {
                let sound = await myIpfs.getSound(hash, 30000);
            } catch (err) {
                console.log('rejected the sound!');
                reject(err);
                return;
            }
            ipfs.pin.add(hash, async (err, res) => {
                if (err) {
                    reject(err);
                } else {
		    this.pinnedSounds.add(hash);
                    this.pinningSounds.delete(hash);
                    if (this.failedSounds.has(hash)) {
                        this.failedSounds.delete(hash);
                    }

		    console.log('pinned i = ' + this.pinnedSounds.size + ' '  + title + ' (failures = ' + this.failedSounds.size + ')');
                    
                    if (this.provide) {
                        ipfs.dht.provide(hash, (err, res) => {
                            if (err) {
                                console.log('error providing ' );
                                console.log(err);
                                reject(err);
                            } else {
			       this.providedSounds++;
                                console.log('provided i =' + this.providedSounds + ' '  + hash);
                                success = true;
                                resolve(hash);
                            }
                        });
                    } else {
                        success = true;
                        resolve(hash);
                    }
                }
            });
        });
    }
}

function bytes32ToIPFSHash(hash_hex) {
    var buf = new Buffer(hash_hex.replace(/^0x/, '1220'), 'hex')
    return bs58.encode(buf)
}


export default Pinner;
